import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'

export class Select extends React.PureComponent {
  onChange(e) {
    e.preventDefault()
    const val = e.target.value
    this.props.onChange(val)
  }

  render() {
    return (
      <select
        className={midas.formSelect}
        value={this.props.value}
        onChange={e => this.onChange(e)}
      >
        {this.props.values.map((val, index) => (
          <option key={val} value={val}>
            {this.props.names[index]}
          </option>
        ))}
      </select>
    )
  }
}

Select.propTypes = {
  values: PropTypes.array.isRequired,
  names: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Select.defaultProps = {
  value: -1,
}
